<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<mat-card [ngStyle]="{'width.px': width, 'height.px': height}">
    <h1>実行履歴情報</h1>

    <div class="insert-user" fxLayout="row">
        <mat-group color="warn" class="execution-group" fxFlex="94" fxFlex.lt-md="100"
            style="position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px">
            <mat-label class="form-execution-user"
                style="position: absolute; color: rgb(0, 0, 0); background-color: white;">
                登録者</mat-label>
            <mat-form-field appearance="fill" class="form-organization" fxFlex="38" fxFlex.lt-md="100">
                <mat-label>組織名</mat-label>
                <input matInput [disabled]="true" value="{{regperSoshikiName}}" class="font-color-display-only">
            </mat-form-field>
            <mat-form-field appearance="fill" class="form-person" fxFlex="38" fxFlex.lt-md="100">
                <mat-label>登録者</mat-label>
                <input matInput [disabled]="true" value="{{regpernm}}" class="font-color-display-only">
            </mat-form-field>
            <mat-form-field appearance="fill" class="form-day" fxFlex="18" fxFlex.lt-md="100">
                <mat-label>登録日時</mat-label>
                <input matInput [disabled]="true" value="{{regDate}}" class="font-color-display-only">
            </mat-form-field>
        </mat-group>
    </div>

    <div class="update-user" fxLayout="row">
        <mat-group color="warn" class="execution-group" fxFlex="94" fxFlex.lt-md="100"
            style="position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px">
            <mat-label class="form-execution-user"
                style="position: absolute; color: rgb(0, 0, 0); background-color: white;">
                更新者</mat-label>
            <mat-form-field appearance="fill" class="form-organization" fxFlex="38" fxFlex.lt-md="100">
                <mat-label>組織名</mat-label>
                <input matInput [disabled]="true" value="{{updaterSoshikiName}}" class="font-color-display-only">
            </mat-form-field>
            <mat-form-field appearance="fill" class="form-person" fxFlex="38" fxFlex.lt-md="100">
                <mat-label>更新者</mat-label>
                <input matInput [disabled]="true" value="{{updaternm}}" class="font-color-display-only">
            </mat-form-field>
            <mat-form-field appearance="fill" class="form-day" fxFlex="18" fxFlex.lt-md="100">
                <mat-label>更新日時</mat-label>
                <input matInput [disabled]="true" value="{{updateDate}}" class="font-color-display-only">
            </mat-form-field>
        </mat-group>
    </div>

    <div *ngIf="apprvOnFlg !== '0'">
        <div class="approval-user" fxLayout="row">
            <mat-group color="warn" class="execution-group" fxFlex="94" fxFlex.lt-md="100"
                style="position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px">
                <mat-label class="form-execution-user"
                    style="position: absolute; color: rgb(0, 0, 0); background-color: white;">
                    承認者</mat-label>
                <mat-form-field appearance="fill" class="form-organization" fxFlex="38" fxFlex.lt-md="100">
                    <mat-label>組織名</mat-label>
                    <input matInput [disabled]="true" value="{{apprvrSoshikiName}}" class="font-color-display-only">
                </mat-form-field>
                <mat-form-field appearance="fill" class="form-person" fxFlex="38" fxFlex.lt-md="100">
                    <mat-label>承認者</mat-label>
                    <input matInput [disabled]="true" value="{{apprvrnm}}" class="font-color-display-only">
                </mat-form-field>
                <mat-form-field appearance="fill" class="form-day" fxFlex="18" fxFlex.lt-md="100">
                    <mat-label>承認日時</mat-label>
                    <input matInput [disabled]="true" value="{{apprvDate}}" class="font-color-display-only">
                </mat-form-field>
            </mat-group>
        </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="center center" class="div-button-close">
        <button type="button" mat-raised-button color="primary" class="btn btn-short layout-margin"
            (click)="close()">閉じる</button>
    </div>
</mat-card>